import React, { useState, useEffect, Fragment } from "react";

import { observer } from "mobx-react-lite";
import { makeStyles } from "@mui/styles";
import { useStores } from "../../../core/stores/index";
import { useMsal } from "@azure/msal-react";
import { SiteSessionService } from "core/services/SiteSessionService";
import "./Home.css";
import { PieChart } from "@mui/x-charts/PieChart";
import { useSnackbar } from "notistack";

import { IHomePageData } from "../../../common/interfaces/IHomePageData";
import { PieValueType } from "@mui/x-charts";
import { MakeOptional } from "@mui/x-date-pickers/internals";

interface HomeProp {
    children: JSX.Element;
}

export const Home = observer((props: HomeProp) => {
    const { userStore, claimStore } = useStores();

    const [outstandingData, setData] = useState<IHomePageData | undefined>(undefined);

    const [managerData, setManagerData] = useState<MakeOptional<PieValueType, "id">[]>([]);

    const [customerData, setCustomerData] = useState<MakeOptional<PieValueType, "id">[]>([]);
    const snackbar = useSnackbar();
    useEffect(() => {
        userStore.setCurrentUser();

        claimStore.getOutstandingClaims().then((response) => {
            if (response.success) {
                console.log(response);
                setData(response);

                setManagerData(
                    response?.topFiveManagersWithPriceOutstanding?.map((x: any) => ({
                        id: x.id as number,
                        value: x.claimCount as string,
                        label: x.accountManagerName as string,
                    }))
                );

                setCustomerData(
                    response?.topFiveCustomerWithPriceOutstanding?.map((x: any) => ({
                        id: x.id as number,
                        value: x.claimCount as string,
                        label: x.customerAccount as string,
                    })));
                
            } else {
                snackbar.enqueueSnackbar(response.message, {
                    variant: "error",
                });
            }
        });
    }, []);

    useEffect(() => {
        console.log(managerData);
    }, [managerData]);

    return (
        <>
            {userStore.currentUser && (
                <div className="container">
                    <div className="row ml-0 mr-0 h-50">
                        <div className="col-md-6 p-10">
                            <div className="row ml-0 mr-0 h-50">
                                <h4 className="w-75 m-md-auto pt-2 text-center headerStyle">Price Claims</h4>
                                <div className="w-75 m-md-auto pt-2 text-center">Total Outstanding: {outstandingData?.totalOustandingPriceClaims}</div>
                                <div className="w-75 m-md-auto pt-2 pb-3 text-center">
                                    Outstanding &gt; 10 days: {outstandingData?.totalOustandingForOverTenDaysPriceClaims}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 p-10">
                            <div className="row ml-0 mr-0 h-50">
                                <h4 className="w-75 m-md-auto pt-2 text-center headerStyle">Inventory Claims</h4>
                                <div className="w-75 m-md-auto pt-2 text-center">Total Outstanding: {outstandingData?.totalOustandingInventoryClaims}</div>
                                <div className="w-75 m-md-auto pt-2 pb-3 text-center">
                                    Outstanding &gt; 10 days: {outstandingData?.totalOustandingForOverTenDaysInventoryClaims}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    <div className="row ml-0 mr-0 h-50">
                        <div className="col-md-6 p-10">
                            <h4 className="w-75 m-md-auto pt-2 text-center headerStyle">Top 5 Managers with Price Claims Outstanding</h4>
                            <div className="w-75 m-md-auto pt-2 text-center">
                                {managerData && (
                                    <PieChart
                                    margin={{ top: 10, bottom: 100, left: 100, right:100 }}
                                        series={[
                                            {
                                                data: managerData,
                                            },
                                        ]}
                                        width={450}
                                        height={450}
                                        slotProps={{ legend: {labelStyle: {fontSize: 15}, direction: "row", position: { vertical: "bottom", horizontal: "middle" }, }}}
                                    ></PieChart>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 p-10">
                            <h4 className="w-75 m-md-auto pt-2 text-center headerStyle">Top 5 Customers with Price Claims Outstanding</h4>
                            <div className="w-75 m-md-auto pt-2 text-center">
                            {customerData && (
                                    <PieChart
                                    margin={{ top: 10, bottom: 100, left: 100, right:100 }}
                                        series={[
                                            {
                                                data: customerData,
                                            },
                                        ]}
                                        width={450}
                                        height={450}
                                        slotProps={{ legend: { labelStyle: {fontSize: 15}, direction: "column", position: { vertical: "bottom", horizontal: "middle" } } }}
                                    ></PieChart>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
});
